import React from 'react';
import AuthRouter from './routes/AuthRouter';



function App() {
  return (
    <AuthRouter />
  );
}

export default App;

